import _definePage_default_0 from '/app/apps/admin/src/pages/index.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/apps/admin/src/pages/analytics/index.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/app/apps/admin/src/pages/bibs/index.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/app/apps/admin/src/pages/documents/security/index.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/app/apps/admin/src/pages/email/index.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/app/apps/admin/src/pages/events/index.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/app/apps/admin/src/pages/events/gallery.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/app/apps/admin/src/pages/events/results.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/app/apps/admin/src/pages/feature-flags/index.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/app/apps/admin/src/pages/invitations/index.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/app/apps/admin/src/pages/invitations/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/app/apps/admin/src/pages/invitations/results/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_13 from '/app/apps/admin/src/pages/otp-lockouts/index.vue?definePage&vue&lang.tsx'
import _definePage_default_14 from '/app/apps/admin/src/pages/participants/index.vue?definePage&vue&lang.tsx'
import _definePage_default_15 from '/app/apps/admin/src/pages/pending-otp/index.vue?definePage&vue&lang.tsx'
import _definePage_default_16 from '/app/apps/admin/src/pages/registrations/index.vue?definePage&vue&lang.tsx'
import _definePage_default_17 from '/app/apps/admin/src/pages/sms/index.vue?definePage&vue&lang.tsx'
import _definePage_default_18 from '/app/apps/admin/src/pages/sms/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_19 from '/app/apps/admin/src/pages/staff/index.vue?definePage&vue&lang.tsx'
import _definePage_default_20 from '/app/apps/admin/src/pages/subscriptions/index.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
    {
      path: '/',
      name: '/',
      component: () => import('/app/apps/admin/src/pages/index.vue'),
      /* no children */
    },
    _definePage_default_0
  ),
  {
    path: '/analytics',
    /* internal name: '/analytics' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/analytics/',
          component: () => import('/app/apps/admin/src/pages/analytics/index.vue'),
          /* no children */
        },
        _definePage_default_2
      )
    ],
  },
  {
    path: '/bibs',
    /* internal name: '/bibs' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/bibs/',
          component: () => import('/app/apps/admin/src/pages/bibs/index.vue'),
          /* no children */
        },
        _definePage_default_3
      )
    ],
  },
  {
    path: '/documents',
    /* internal name: '/documents' */
    /* no component */
    children: [
      {
        path: 'security',
        /* internal name: '/documents/security' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/documents/security/',
              component: () => import('/app/apps/admin/src/pages/documents/security/index.vue'),
              /* no children */
            },
            _definePage_default_4
          ),
          {
            path: 'DocumentScansTable',
            name: '/documents/security/DocumentScansTable',
            component: () => import('/app/apps/admin/src/pages/documents/security/DocumentScansTable.vue'),
            /* no children */
          },
          {
            path: 'ScanAttemptsDialog',
            name: '/documents/security/ScanAttemptsDialog',
            component: () => import('/app/apps/admin/src/pages/documents/security/ScanAttemptsDialog.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/email',
    /* internal name: '/email' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/email/',
          component: () => import('/app/apps/admin/src/pages/email/index.vue'),
          /* no children */
        },
        _definePage_default_5
      )
    ],
  },
  {
    path: '/events',
    /* internal name: '/events' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/events/',
          component: () => import('/app/apps/admin/src/pages/events/index.vue'),
          /* no children */
        },
        _definePage_default_6
      ),
      {
        path: 'EventDetailDialog',
        name: '/events/EventDetailDialog',
        component: () => import('/app/apps/admin/src/pages/events/EventDetailDialog.vue'),
        /* no children */
      },
      _mergeRouteRecord(
        {
          path: 'gallery',
          name: '/events/gallery',
          component: () => import('/app/apps/admin/src/pages/events/gallery.vue'),
          /* no children */
        },
        _definePage_default_7
      ),
      _mergeRouteRecord(
        {
          path: 'results',
          name: '/events/results',
          component: () => import('/app/apps/admin/src/pages/events/results.vue'),
          /* no children */
        },
        _definePage_default_8
      )
    ],
  },
  {
    path: '/feature-flags',
    /* internal name: '/feature-flags' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/feature-flags/',
          component: () => import('/app/apps/admin/src/pages/feature-flags/index.vue'),
          /* no children */
        },
        _definePage_default_9
      )
    ],
  },
  {
    path: '/invitations',
    /* internal name: '/invitations' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/invitations/',
          component: () => import('/app/apps/admin/src/pages/invitations/index.vue'),
          /* no children */
        },
        _definePage_default_10
      ),
      _mergeRouteRecord(
        {
          path: ':id',
          name: '/invitations/[id]',
          component: () => import('/app/apps/admin/src/pages/invitations/[id].vue'),
          /* no children */
        },
        _definePage_default_11
      ),
      {
        path: 'results',
        /* internal name: '/invitations/results' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':id',
              name: '/invitations/results/[id]',
              component: () => import('/app/apps/admin/src/pages/invitations/results/[id].vue'),
              /* no children */
            },
            _definePage_default_12
          )
        ],
      }
    ],
  },
  {
    path: '/login',
    /* internal name: '/login' */
    /* no component */
    children: [
      {
        path: '',
        name: '/login/',
        component: () => import('/app/apps/admin/src/pages/login/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/otp-lockouts',
    /* internal name: '/otp-lockouts' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/otp-lockouts/',
          component: () => import('/app/apps/admin/src/pages/otp-lockouts/index.vue'),
          /* no children */
        },
        _definePage_default_13
      )
    ],
  },
  {
    path: '/participants',
    /* internal name: '/participants' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/participants/',
          component: () => import('/app/apps/admin/src/pages/participants/index.vue'),
          /* no children */
        },
        _definePage_default_14
      ),
      {
        path: 'ParticipantExpansion',
        name: '/participants/ParticipantExpansion',
        component: () => import('/app/apps/admin/src/pages/participants/ParticipantExpansion.vue'),
        /* no children */
      },
      {
        path: 'ParticipantsTable',
        name: '/participants/ParticipantsTable',
        component: () => import('/app/apps/admin/src/pages/participants/ParticipantsTable.vue'),
        /* no children */
      },
      {
        path: 'ParticipantsToolbar',
        name: '/participants/ParticipantsToolbar',
        component: () => import('/app/apps/admin/src/pages/participants/ParticipantsToolbar.vue'),
        /* no children */
      },
      {
        path: 'ParticipationsList',
        name: '/participants/ParticipationsList',
        component: () => import('/app/apps/admin/src/pages/participants/ParticipationsList.vue'),
        /* no children */
      },
      {
        path: 'PersonDetailDialog',
        name: '/participants/PersonDetailDialog',
        component: () => import('/app/apps/admin/src/pages/participants/PersonDetailDialog.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/pending-otp',
    /* internal name: '/pending-otp' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/pending-otp/',
          component: () => import('/app/apps/admin/src/pages/pending-otp/index.vue'),
          /* no children */
        },
        _definePage_default_15
      )
    ],
  },
  {
    path: '/registrations',
    /* internal name: '/registrations' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/registrations/',
          component: () => import('/app/apps/admin/src/pages/registrations/index.vue'),
          /* no children */
        },
        _definePage_default_16
      ),
      {
        path: 'ApplicationCard',
        name: '/registrations/ApplicationCard',
        component: () => import('/app/apps/admin/src/pages/registrations/ApplicationCard.vue'),
        /* no children */
      },
      {
        path: 'ApplicationMembersTable',
        name: '/registrations/ApplicationMembersTable',
        component: () => import('/app/apps/admin/src/pages/registrations/ApplicationMembersTable.vue'),
        /* no children */
      },
      {
        path: 'ApplicationsKanban',
        name: '/registrations/ApplicationsKanban',
        component: () => import('/app/apps/admin/src/pages/registrations/ApplicationsKanban.vue'),
        /* no children */
      },
      {
        path: 'ApplicationsTable',
        name: '/registrations/ApplicationsTable',
        component: () => import('/app/apps/admin/src/pages/registrations/ApplicationsTable.vue'),
        /* no children */
      },
      {
        path: 'ChecklistBadges',
        name: '/registrations/ChecklistBadges',
        component: () => import('/app/apps/admin/src/pages/registrations/ChecklistBadges.vue'),
        /* no children */
      },
      {
        path: 'DocumentsPanel',
        name: '/registrations/DocumentsPanel',
        component: () => import('/app/apps/admin/src/pages/registrations/DocumentsPanel.vue'),
        /* no children */
      },
      {
        path: 'EmailContact',
        name: '/registrations/EmailContact',
        component: () => import('/app/apps/admin/src/pages/registrations/EmailContact.vue'),
        /* no children */
      },
      {
        path: 'ForceStatusDialog',
        name: '/registrations/ForceStatusDialog',
        component: () => import('/app/apps/admin/src/pages/registrations/ForceStatusDialog.vue'),
        /* no children */
      },
      {
        path: 'PhoneContact',
        name: '/registrations/PhoneContact',
        component: () => import('/app/apps/admin/src/pages/registrations/PhoneContact.vue'),
        /* no children */
      },
      {
        path: 'RegistrationDetailDialog',
        name: '/registrations/RegistrationDetailDialog',
        component: () => import('/app/apps/admin/src/pages/registrations/RegistrationDetailDialog.vue'),
        /* no children */
      },
      {
        path: 'RegistrationsToolbar',
        name: '/registrations/RegistrationsToolbar',
        component: () => import('/app/apps/admin/src/pages/registrations/RegistrationsToolbar.vue'),
        /* no children */
      },
      {
        path: 'TeamDetailDialog',
        name: '/registrations/TeamDetailDialog',
        component: () => import('/app/apps/admin/src/pages/registrations/TeamDetailDialog.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/sms',
    /* internal name: '/sms' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/sms/',
          component: () => import('/app/apps/admin/src/pages/sms/index.vue'),
          /* no children */
        },
        _definePage_default_17
      ),
      _mergeRouteRecord(
        {
          path: ':id',
          name: '/sms/[id]',
          component: () => import('/app/apps/admin/src/pages/sms/[id].vue'),
          /* no children */
        },
        _definePage_default_18
      )
    ],
  },
  {
    path: '/staff',
    /* internal name: '/staff' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/staff/',
          component: () => import('/app/apps/admin/src/pages/staff/index.vue'),
          /* no children */
        },
        _definePage_default_19
      )
    ],
  },
  {
    path: '/subscriptions',
    /* internal name: '/subscriptions' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/subscriptions/',
          component: () => import('/app/apps/admin/src/pages/subscriptions/index.vue'),
          /* no children */
        },
        _definePage_default_20
      )
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

